module.exports = __webpack_public_path__ + "static/media/Calidad.404ad740.svg";